<template>
  <div class="deleteForm">
    <p class="control" @click="deleteSchedule()">
    <a class="button is-danger">
      削除
    </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'DeleteSchedule',
  methods: {
    deleteSchedule () {
      console.debug('*** Start *** deleteSchedule')
      this.$store.dispatch('calendar/deleteSchedule')
      console.debug('*** End *** deleteSchedule')
    }
  }
}
</script>

<style scoped>
.deleteForm {
    margin: 0px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/DeleteSchedule.vue